import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link, useNavigate } from 'react-router-dom';
import { HamburgerMenu } from './components';
import {
  HomePage,
  AgendaPage,
  SpeakersPage,
  LoginPage,
  RegistroPage,
  DashboardPage,
  EncuestaPage,
  StreamingPage,
  PromocionesPage,
} from './pages';
import { useConfig } from './context/ConfigContext';
import { getConfigStyles } from './utils/configStyles';
import { authStorage } from './utils/auth';
import './App.css';

function AppContent() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { config, loading } = useConfig();
  const configStyles = getConfigStyles(config);
  const isLoggedIn = !!authStorage.getToken();

  useEffect(() => {
    document.title = config?.tabTitle || '';
  }, [config?.tabTitle]);

  const handleLogout = () => {
    authStorage.clear();
    setMenuOpen(false);
    navigate('/login', { replace: true });
  };

  const menuItems = isLoggedIn
    ? [
        { label: 'Inicio', href: '/dashboard' },
        { label: 'Speakers', href: '/speakers' },
        { label: 'Agenda', href: '/agenda' },
        { label: 'Streaming', href: '/streaming' },
        { label: 'Promociones', href: '/promociones' },
        { label: 'Cerrar sesión', onClick: handleLogout },
      ]
    : [
        { label: 'Iniciar sesión', href: '/login' },
        { label: 'Registro', href: '/registro' },
      ];

  const bodyStyle = {};
  if (configStyles.bodyBackgroundImage) {
    bodyStyle.backgroundImage = `url(${configStyles.bodyBackgroundImage})`;
    bodyStyle.backgroundSize = 'cover';
    bodyStyle.backgroundAttachment = 'fixed';
  } else if (configStyles.bodyBackground) {
    bodyStyle.backgroundColor = configStyles.bodyBackground;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <p className="text-gray-500">Cargando...</p>
      </div>
    );
  }

  const additionalLogos = isLoggedIn ? (configStyles.additionalLogos || []) : [];

  return (
    <div
        className={`min-h-screen relative ${Object.keys(bodyStyle).length === 0 ? 'bg-gray-50' : ''}`}
        style={{
          ...configStyles.style,
          ...bodyStyle,
        }}
      >
        {additionalLogos.filter((l) => l?.url).map((logo, idx) => (
          <div
            key={idx}
            className="fixed pointer-events-none z-20"
            style={{
              left: `${logo.x ?? 10}%`,
              top: `${logo.y ?? 10}%`,
              width: logo.width || 60,
              height: logo.height || 40,
            }}
          >
            
          </div>
        ))}

        {/* Menú hamburguesa - fijo en esquina superior derecha */}
        <div className="fixed top-4 right-4 z-40">
          <HamburgerMenu
            isOpen={menuOpen}
            onToggle={() => setMenuOpen(!menuOpen)}
            items={menuItems}
            className="bg:black/70 [&_button]:bg-white/20 [&_button]:hover:bg-white/30 [&_button]:rounded-lg [&_button]:p-2"
          />
        </div>

        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/agenda" element={<AgendaPage />} />
            <Route path="/speakers" element={<SpeakersPage />} />
            <Route path="/streaming" element={<StreamingPage />} />
            <Route path="/promociones" element={<PromocionesPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/registro" element={<RegistroPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/encuesta" element={<EncuestaPage />} />
          </Routes>
        </main>        
      </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
